<template>
    <div
        class="w-full h-full text-base p-6 space-y-4"
        :style="{
            color: player.textColor,
        }"
        v-html="fileTextContent"
    ></div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { richTextModel } from "@easy/ui/forms";

export default {
    name: "FileText",
    computed: {
        ...mapState("player/view", ["player"]),
        ...mapGetters("player/view", ["currentFile"]),
        fileTextContent() {
            return this.currentFile.text
                ? richTextModel.parseToHTMLFromMarkdown(this.currentFile.text)
                : "";
        },
    },
};
</script>
